import publicRoutes from "@/router/routes/public.js";
import privateRoutes from "@/router/routes/private.js";

const markPrivateRouteTree = (route) => ({
  ...route,
  meta: {
    ...(route.meta || {}),
    public: false,
  },
  children: route.children?.map(markPrivateRouteTree),
});

export default publicRoutes.concat(privateRoutes.map(markPrivateRouteTree));
